// extracted by mini-css-extract-plugin
export default {"overlayAsset1":"RPr3XRe1ON9XpkGbTRi26"};